import { createSlice } from '@reduxjs/toolkit';

interface UTMState {
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
  utm_content: string | null;
  utm_term: string | null;
}

const initialState: UTMState = {
  utm_source: null,
  utm_medium: null,
  utm_campaign: null,
  utm_content: null,
  utm_term: null,
};

const utmSlice = createSlice({
  name: 'utm',
  initialState,
  reducers: {
    setUTM: (state, action) => {
      state.utm_source = action.payload.utm_source;
      state.utm_medium = action.payload.utm_medium;
      state.utm_campaign = action.payload.utm_campaign;
      state.utm_content = action.payload.utm_content;
      state.utm_term = action.payload.utm_term;
    },
    resetUTM: (state) => {
      state.utm_source = null;
      state.utm_medium = null;
      state.utm_campaign = null;
      state.utm_content = null;
      state.utm_term = null;
    },
  },
});

export const { setUTM } = utmSlice.actions;

export default utmSlice.reducer;
